import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/store";
import { getMenuItems } from "./components/ModulesMenu/utils";
import { useLocation } from "react-router-dom";
import { setClientId, setSelectedMenu } from "src/store/slices/client";
import { cancelTimer } from "src/store/slices/timer";

export default function useModuleSelect() {
  const menuItems = useSelector((state: RootState) => state.client.menuItems);
  const selectedMenu = useSelector((state: RootState) => state.client.selectedMenu);
  const selectedClientId = useSelector((state: RootState) => state.client.selectedClientId);
  const items = getMenuItems(menuItems);
  const dispatch = useDispatch<AppDispatch>();
  const { pathname } = useLocation();

  const route = pathname.split("/").filter(Boolean)[0];
  const activeKey = items.find((item) => item.route === route)?.key ?? "";

  const handleSelection = (key: string) => {
    const item = items.find((el) => el.key === key);
    if (!item) return;
    if (item.isstatic) {
      dispatch(setSelectedMenu(item.type));
    }
    if (!item.isstatic) {
      dispatch(setSelectedMenu(item.type));
      dispatch(setClientId(item.key));
    }
    dispatch(cancelTimer());
  };

  return { items, selectedMenu, selectedClientId, activeKey, handleSelection };
}
